"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUploadFile = exports.isObject = exports.isFileList = exports.ReactNativeFile = void 0;
const isObject = value => value !== null && typeof value === "object";
exports.isObject = isObject;
const isFileList = value => typeof FileList !== "undefined" && value instanceof FileList;
exports.isFileList = isFileList;
const isUploadFile = value => typeof File !== "undefined" && value instanceof File || typeof Blob !== "undefined" && value instanceof Blob || value instanceof ReactNativeFile;

/**
 * A React Native FormData file object.
 * @see {@link https://github.com/facebook/react-native/blob/v0.45.1/Libraries/Network/FormData.js#L34}
 */
exports.isUploadFile = isUploadFile;
/**
 * A React Native file.
 */
class ReactNativeFile {
  /**
   * Creates an array of file instances.
   *
   * @example
   * const files = ReactNativeFile.list([{
   *   uri: uriFromCameraRoll1,
   *   type: 'image/jpeg',
   *   name: 'photo-1.jpg'
   * }, {
   *   uri: uriFromCameraRoll2,
   *   type: 'image/jpeg',
   *   name: 'photo-2.jpg'
   * }])
   */
  static list = files => files.map(file => new ReactNativeFile(file));
  /**
   * Constructs a new file.
   *
   * @example
   * const file = new ReactNativeFile({
   *  uri: uriFromCameraRoll,
   *  type: 'image/jpeg',
   *  name: 'photo.jpg'
   * })
   */
  constructor(_ref) {
    let {
      uri,
      type,
      name
    } = _ref;
    this.uri = uri;
    this.type = type;
    this.name = name;
  }
}
exports.ReactNativeFile = ReactNativeFile;
//# sourceMappingURL=validators.js.map